import logger from 'ws-scripts/modules/logger';
import inTestSuite from './inTestSuite';
import isObject from './isObject';

const loggerLevels = ['fatal', 'error', 'warn', 'info', 'debug', 'trace'];

/**
 *
 * @param {string} msg The message to send to logger.info if not in the test suite
 * @returns
 */
const logIfNotInTestSuite = ({ msg, data, level = 'info' }) => {
	const args = [msg];
	const loggerLevel = loggerLevels.includes(level) ? level : 'info';
	let dataShallowCopy = data;

	if (isObject(data)) {
		dataShallowCopy = {
			...data,
			...(data?.eventData && {
				eventData: {
					...data.eventData
				}
			})
		};
	}

	if (dataShallowCopy) {
		args.push(dataShallowCopy);
	}

	return typeof window === 'undefined'
		? logger[loggerLevel](...args)
		: !inTestSuite(window) && logger[loggerLevel](...args);
};

export default logIfNotInTestSuite;
